import React from 'react';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsStepFlow as WidgetsStepFlowView } from 'modules/widgetsStepFlow';
import { widgetsStepFlowPreloader as WidgetsStepFlowPreloader } from 'modules/widgetsStepFlow';

// success view
export const callAuthorizationFlowSuccess = ( props ) => {
	return (
		<div className="ui-call-authorization-flow">
			<WidgetsStepFlowView
				activeStepIndex={props.currentStep - 1}
				steps={props.steps}
			/>
		</div>
	);
};

// set display name
callAuthorizationFlowSuccess.displayName = 'callAuthorizationFlowSuccess';

// set default props
callAuthorizationFlowSuccess.defaultProps = {
	currentStep: 1,
	steps: [],
};

// prop types
callAuthorizationFlowSuccess.propTypes = {};

/*******************************/

// preloader view
export const callAuthorizationFlowPreloader = () => {
	return (
		<div className="ui-call-authorization-flow-preloader">
			<WidgetsStepFlowPreloader />
		</div>
	);
};

// set display name
callAuthorizationFlowPreloader.displayName = 'callAuthorizationFlowPreloader';

// set default props
callAuthorizationFlowPreloader.defaultProps = {};

// prop types
callAuthorizationFlowPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callAuthorizationFlow as CallAuthorizationFlow } from 'ui/views/widgets/callAuthorizationFlow';
 *
 * // render
 * <CallAuthorizationFlow propName='propValue'/>
 */
export const callAuthorizationFlow = withNetworkState(
	callAuthorizationFlowPreloader,
	callAuthorizationFlowSuccess
);
